import { IncidentTypes } from "@/features/settings/incident-types";

export const Route = createFileRoute({
  component: IncidentTypes,
});
